<template>
  <div class="request-container">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-container>
        <v-row>
          <h4>{{$t('home.content.interests.subtitle')}}</h4>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field clearable v-model="request.hotel"
                          :label="$t('home.content.interests.hotel')" color="white"
                          outlined required :rules="rules"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field clearable v-model="request.name"
                          :label="$t('home.content.interests.nameAndPosition')" color="white"
                          outlined required :rules="rules"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field clearable v-model="request.email"
                          label="E-Mail" color="white"
                          outlined required :rules="emailRules"
            />
          </v-col>
        </v-row>
        <v-layout wrap>
          <v-flex xs12 mb-4>
            <v-textarea v-model="request.message"
                        outlined color="white"
                        :label="$t('home.content.interests.message')"
                        counter="1000" rows="8"
                        required :rules="rules"
                        auto-grow clearable
            />
          </v-flex>
          <v-flex xs12 sm6 class="text-center">
            <recaptcha ref="recaptchaRequest" :recaptchId="'request_form'" @verify="submit"
                       style="display: inline-block;"/>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout wrap justify-center align-center style="height: 100%">
              <v-btn color="white"
                     :loading="loading" :disabled="loading"
                     @click="validate" large>
                <span v-if="!response.success && !response.error">
                  <v-icon left>message</v-icon>
                  {{$t('contact.request.text')}}
                </span>
                <span v-if="response.success">
                  <v-icon left color="success">done</v-icon>
                  {{$t('contact.request.text')}}
                </span>
                <span v-if="response.error">
                  <v-icon left color="warning">error_outline</v-icon>
                  {{$t('contact.request.resend')}}
                </span>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap mt-2>
          <v-flex xs12>
            <v-alert class="pa-2" color="success"
                     style="width: 100%; color: white;"
                     icon="check_circle" :value="response.success">
              {{$t('contact.request.success')}}
            </v-alert>
            <v-alert class="pa-2" color="error"
                     style="width: 100%; color: white;"
                     icon="warning" :value="response.error">
              {{$t('contact.request.error')}}
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  const Recaptcha = () => import('../../components/contact/Recaptcha');

  export default {
    name: 'Request',
    components: {
      Recaptcha,
    },
    data() {
      return {
        valid: undefined,
        loading: false,
        rules: [
          v => !!v || this.$i18n.t('form.required')
        ],
        emailRules: [
          v => !!v || this.$i18n.t('form.required'),
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('form.email.valid')
        ],
        request: {
          name: undefined,
          email: undefined,
          hotel: undefined,
          message: undefined
        },
        response: {
          success: false,
          error: false
        },
      };
    },
    mounted() {
      this.globalEvents.$on('languageChanged', () => {
        this.$refs.form.resetValidation();
        this.rules = [
          v => !!v || this.$i18n.t('form.required')
        ];
        this.emailRules = [
          v => !!v || this.$i18n.t('form.required'),
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('form.email.valid')
        ];
      });
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$refs.recaptchaRequest.execute();
        }
      },
      submit(response) {
        this.request.reCaptchaToken = response;
        const contactRequestDTO = {
          reCaptchaToken: response,
          requestDTO: {
            name: this.request.name,
            email: this.request.email,
            message: this.request.message,
            hotel: this.request.hotel,
            read: false
          }
        };
        this.$http.post('request', contactRequestDTO).then(
          () => {
            this.loading = false;
            this.response.success = true;
            this.$refs.form.reset();
          },
          () => {
            this.loading = false;
            this.response.error = true;
          },
        );
      }
    }
  };
</script>

<style lang="scss">
  @import "../../assets/scss/variables";

  .request-container {
    background: url('https://toursol.at/static/images/request_background.jpg') no-repeat center center fixed;
    background-size: cover;
    padding-bottom: 45px;
    h4 {
      color: white;
      font-weight: 300;
      margin-top: 45px;
      margin-bottom: 45px;
      width: 100%;
    }
    .v-text-field--outlined fieldset {
      border-color: white !important;
    }
    .v-text-field--outlined.v-input--has-state fieldset {
      border-color: #ff5252 !important;
    }
    .v-label, .v-input input {
      color: white !important;
    }
    .v-input--has-state.error--text .v-label {
      color: #ff5252 !important;
    }
    .v-counter {
      color: white;
    }
    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
      color: white;
    }
    .v-icon {
      color: white;
    }
    .v-btn {
      color: $primary;
    }
  }
</style>
